// 1. x-ultra-first
// 整页隐藏切换，文字等缓入（跟随页面滚动）
(function () {
  if (document.querySelector('.x-ultra-first')) {
    gsap.registerPlugin(ScrollTrigger)
    const tl = gsap.timeline({
      scrollTrigger: {
        trigger: '.x-ultra-first',
        start: "top top",
        end: "+=800",
        scrub: true,
        pin: true,
        // markers: true,
      }
    })
    tl.to(".x-ultra-first__box1", {
      duration: 1,
      opacity: 0,
      ease: "power1.out",
    })
      .to(".x-ultra-first__video", {
        duration: 1,
        opacity: 1,
        ease: "power1.out",
      }, '<')
      .to(".x-ultra-first__box2-title", {
        duration: 2,
        opacity: 1,
        y: "-=70",
        ease: "power1.out",
      })
      .to(".x-ultra-first__box2", {
        duration: 1,
        top: 0,
        ease: "power1.out",
      })
      .to(".x-ultra-first__box2-content li:nth-child(1)",
        { opacity: 1, y: "-=70", duration: 0.6, ease: "power1.out" }, '<'
      )
      .to(".x-ultra-first__box2-content li:nth-child(2)",
        { opacity: 1, y: "-=70", duration: 0.6, ease: "power1.out" }, "-=0.4" // overlap animations
      )
      .to(".x-ultra-first__box2-content li:nth-child(3)",
        { opacity: 1, y: "-=70", duration: 0.6, ease: "power1.out" }, "-=0.4"
      )
      .to(".x-ultra-first__box2-content li:nth-child(4)",
        { opacity: 1, y: "-=70", duration: 0.6, ease: "power1.out" }, "-=0.4"
      );
  }
})();

// 2. x-ultra-slogan
// 文字逐渐放大，显示底部图片（跟随页面滚动）
(function () {
  if (document.querySelector('.x-ultra-slogan')) {
    gsap.registerPlugin(ScrollTrigger);
    const tl = gsap.timeline({
      scrollTrigger: {
        trigger: '.x-ultra-slogan',
        start: "top top",
        end: "center top",
        scrub: true,
        pin: true,
      }
    })
    tl.to(".x-ultra-slogan__title", {
      duration: 1,
      opacity: 1,
      ease: "power2.out",
    })
      .to(".x-ultra-slogan__title", {
        duration: 2,
        fontSize: "900px",
      })
      .to(".x-ultra-slogan-main", {
        duration: 2,
        opacity: 0,
        ease: "power2.out",
      })
  }
})();

// 3.x-ultra-advantage
// 文字变色
(function () {
  if (document.querySelector('.x-ultra-advantage')) {
    gsap.registerPlugin(ScrollTrigger)

    const advantageText = document.querySelectorAll('.x-ultra-advantage-list strong');

    ScrollTrigger.create({
      trigger: '.x-ultra-advantage',
      start: "top 5%",
      end: "bottom top",
      scrub: true,
      // markers: true,  // 启用调试标记
      onEnter: () => {
        gsap.to(advantageText[0], { backgroundImage: "linear-gradient(91deg, #2CC7FF 4.27%, #00EE9B 93.23%)", duration: 1 });
        gsap.to(advantageText[1], { backgroundImage: "linear-gradient(91deg, #D859FF 4.27%, #7353FF 93.23%)", duration: 1 });
        gsap.to(advantageText[2], { backgroundImage: "linear-gradient(91deg, #FFE3B9 4.27%, #AD946D 93.23%)", duration: 1 });
        gsap.to(advantageText[3], { backgroundImage: "linear-gradient(91deg, #FF5429 4.27%, #FF53EE 93.23%)", duration: 1 });
      },
      onLeaveBack: () => {
        gsap.to(advantageText, { backgroundImage: "linear-gradient(180deg, #FFF 20.69%, rgba(255, 255, 255, 0.60) 75.86%)", duration: 1 });
      }
    });
  }
})();

// 4.x-ultra-sensitivity
// 左右进入视口（跟随页面滚动）
(function () {
  if (document.querySelector('.x-ultra-sen')) {
    gsap.registerPlugin(ScrollTrigger)
    const tl = gsap.timeline({
      scrollTrigger: {
        trigger: '.x-ultra-sen',
        start: "top top",
        end: "center top",
        scrub: true,
        pin: true,
        // markers: true,
      }
    })
    tl.from(".x-ultra-sen-title", {
      duration: 1,
      opacity: 0,
      ease: "power1.out",
      xPercent: -100,
    })
      .from(".x-ultra-sen-glasses", {
        duration: 1,
        opacity: 0,
        ease: "power1.out",
        xPercent: 100,
      }, '<')
  }
})();

// 5.x-ultra-sensors
// 文字缓入（跟随页面滚动）
(function () {
  if (document.querySelector('.x-ultra-sensors')) {
    gsap.registerPlugin(ScrollTrigger)
    const tl = gsap.timeline({
      scrollTrigger: {
        trigger: '.x-ultra-sensors',
        start: "top top",
        end: "bottom top",
        scrub: true,
        pin: true,
        // markers: true,
      }
    })
    tl.from(".x-ultra-sensors__box-title", {
      duration: 1,
      opacity: 0,
      ease: "power1.out",
      yPercent: 100,
    })
      .from(".x-ultra-sensors__box-content li:nth-child(1)",
        { opacity: 0, yPercent: 100, duration: 0.6, ease: "power1.out" } // overlap animations
      )
      .from(".x-ultra-sensors__box-content li:nth-child(2)",
        { opacity: 0, yPercent: 100, duration: 0.6, ease: "power1.out" }, "-=0.4"
      )
      .from(".x-ultra-sensors__box-content li:nth-child(3)",
        { opacity: 0, yPercent: 100, duration: 0.6, ease: "power1.out" }, "-=0.4"
      );
  }
})();

// 6.x-ultra-immersion
// 文字缓入
(function () {
  if (document.querySelector('.x-ultra-immersion')) {
    gsap.registerPlugin(ScrollTrigger)
    gsap.from(".x-ultra-immersion-content", {
      opacity: 0,
      y: 70,
      duration: 1,
      ease: "power1.out",
      scrollTrigger: {
        trigger: ".x-ultra-immersion",
        start: "top center",
        toggleActions: "play none none reset",
      }
    });
  }
})();

function onTapUltraLink(link) {
  // 跳转链接
  window.location.href = link;
}